<div class="participant">
    <div class="participant-info participant-image-container">
        <ms-participant-image
            class="participant-logo"
            [participantImage]="event.participants[0].image"
            [sportId]="event.sport.id"
            [shouldRotate]="rotateImage[0]">
        </ms-participant-image>
        <ms-scoreboard-participant
            class="participant-info"
            [event]="event"
            [participant]="event.participants[0]"
            [isNewEDPScoreboard]="isNewEDPScoreboard"
            [showIndicator]="false">
        </ms-scoreboard-participant>
    </div>
    <ng-container *ngIf="cricketScore && cricketScore.firstInnings">
        <div
            [ngTemplateOutlet]="!innings.team1.isScoringTeam ? nonScoringTeamTemplate : scoringTeamTemplate"
            [ngTemplateOutletContext]="{ team: cricketScore.firstInnings.team1, isFirstInnings: true }"></div>
    </ng-container>

    <ng-container *ngIf="cricketScore && cricketScore.secondInnings">
        <div class="secondInnings">
            <div
                [ngTemplateOutlet]="!innings.team1.isScoringTeam ? nonScoringTeamTemplate : scoringTeamTemplate"
                [ngTemplateOutletContext]="{ team: innings.team1, isFirstInnings: false }"></div>
        </div>
    </ng-container>
    <ng-container *ngIf="cricketScore && cricketScore.superOver">
        <div
            [ngTemplateOutlet]="!innings.team1.isScoringTeam ? nonScoringTeamTemplate : scoringTeamTemplate"
            [ngTemplateOutletContext]="{ team: innings.team1 }"></div>
    </ng-container>
</div>
<div class="participant">
    <div class="participant-info participant-image-container">
        <ms-participant-image
            class="participant-logo"
            [participantImage]="event.participants[1].image"
            [sportId]="event.sport.id"
            [shouldRotate]="rotateImage[1]">
        </ms-participant-image>
        <ms-scoreboard-participant
            class="participant-info"
            [event]="event"
            [participant]="event.participants[1]"
            [isNewEDPScoreboard]="isNewEDPScoreboard"
            [showIndicator]="false">
        </ms-scoreboard-participant>
    </div>
    <ng-container *ngIf="cricketScore && cricketScore.firstInnings">
        <div
            [ngTemplateOutlet]="!innings.team2.isScoringTeam ? nonScoringTeamTemplate : scoringTeamTemplate"
            [ngTemplateOutletContext]="{ team: cricketScore.firstInnings.team2, isFirstInnings: true }"></div>
    </ng-container>
    <ng-container *ngIf="cricketScore && cricketScore.secondInnings">
        <div class="secondInnings">
            <div
                [ngTemplateOutlet]="!innings.team2.isScoringTeam ? nonScoringTeamTemplate : scoringTeamTemplate"
                [ngTemplateOutletContext]="{ team: innings.team2, isFirstInnings: false }"></div>
        </div>
    </ng-container>
    <ng-container *ngIf="cricketScore && cricketScore.superOver">
        <div
            [ngTemplateOutlet]="!innings.team2.isScoringTeam ? nonScoringTeamTemplate : scoringTeamTemplate"
            [ngTemplateOutletContext]="{ team: innings.team2 }"></div>
    </ng-container>
</div>
<ng-template #scoringTeamTemplate let-inning="team" let-isFirstInnings="isFirstInnings">
    <div class="set innings" [class.scoring-team]="inning.isScoringTeam">
        <span class="inning-overs">{{
            !!inning.overs ? '(' + inning.overs + '.' + inning.balls + ' ' + sitecoreEventDetails.eventDetails.Overs + ') ' : ''
        }}</span>
        <span>{{ inning.runs }}{{ '/' + inning.wickets }}</span>
    </div>
</ng-template>
<ng-template #nonScoringTeamTemplate let-inning="team" let-isFirstInnings="isFirstInnings">
    <div class="set innings" *ngIf="inning.runs; else staticTemplate" [class.scoring-team]="inning.isScoringTeam">
        <span>{{ inning.runs }}{{ '/' + inning.wickets }}</span>
    </div>
</ng-template>
<ng-template #staticTemplate>
    <div class="set innings">
        <span>-</span>
    </div>
</ng-template>

<div class="header" *ngIf="isNewEDPScoreboard">
    <div class="event-header-live">
        <i class="live-icon"></i>
        <span class="period-name">{{ event.scoreboard.period?.name }}</span>
    </div>
    <div class="event-time">
        <div class="set-point" *ngIf="cricketScore">
            <span *ngIf="cricketScore.superOver; else secondInnings">{{ sitecoreEventDetails.eventDetails.SuperOver }}</span>
            <ng-template #secondInnings>
                <span *ngIf="cricketScore.secondInnings; else firstInnings">{{ sitecoreEventDetails.eventDetails.SecondInnings }}</span>
            </ng-template>
            <ng-template #firstInnings>
                <span *ngIf="cricketScore.firstInnings">{{ sitecoreEventDetails.eventDetails.FirstInnings }}</span>
            </ng-template>
        </div>
    </div>
</div>
